import { ProgressBar } from 'ui'
import React from 'react'
import { useValue } from '@morningtrain/react-resources'

export default function EconomyChecklistProgress () {

  const progress = useValue('checklist_progress')

  return (
    <ProgressBar
      classNames='w-4/5 my-auto mr-2'
      progress={[
        { color: 'bg-primary-500', progress: progress * 100 }
      ]}/>
  )
}